import React from "react"
import Link from "gatsby-link"
import { graphql } from "gatsby"

import { isExternal } from "../utils/url"

import { FooterFieldsFragment } from "../../graphql-types"

const Logo = "/icons/logo_light.svg"

export const query = graphql`
  fragment FooterFields on DatoCmsFooter {
    contactInfo
    columns {
      id
      linksGroup {
        id
        heading
        url
        links {
          id
          title
          url
        }
      }
    }
    bottomLinks {
      id
      title
      url
    }
  }
`

const Footer: React.FunctionComponent<FooterFieldsFragment> = ({
  contactInfo,
  columns,
  bottomLinks,
}) => {
  return (
    <footer>
      <section className="c-footer">
        <div className="o-wrapper u-flex u-flex-wrap">
          <a className="c-footer__logo" href="/">
            <img src={Logo} alt="Northvolt" />
          </a>

          <div className="c-footer__grid">
            <div className="c-footer__grid__item address">
              <div
                className="c-footer__address-container"
                dangerouslySetInnerHTML={{
                  __html: contactInfo,
                }}
              />
              <div className="u-flex c-footer__social">
                <a href="https://twitter.com/northvolt" className="twitter">
                  <span className="is-visually-hidden">Twitter</span>
                </a>
                <a
                  href="https://www.facebook.com/Northvolt/"
                  className="facebook"
                >
                  <span className="is-visually-hidden">Facebook</span>
                </a>
                <a
                  href="https://www.linkedin.com/company/northvolt"
                  className="linkedin"
                >
                  <span className="is-visually-hidden">LinkedIn</span>
                </a>
                <a
                  href="https://www.instagram.com/northvolt/"
                  className="instagram"
                >
                  <span className="is-visually-hidden">Instagram</span>
                </a>
              </div>
            </div>
            {columns.map(column => (
              <div className="c-footer__grid__item" key={column.id}>
                {column.linksGroup.map(group => (
                  <ul className="c-footer__menu" key={group.id}>
                    <li>
                      <Link to={group.url}>{group.heading}</Link>
                    </li>
                    {group.links.map(link => (
                      <li key={link.id}>
                        {isExternal(link.url) ? (
                          <a href={link.url}>{link.title}</a>
                        ) : (
                          <Link to={link.url}>{link.title}</Link>
                        )}
                      </li>
                    ))}
                  </ul>
                ))}
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="c-footer__bottom">
        <div className="o-wrapper u-flex">
          <ul>
            <li>&copy; {new Date().getFullYear()} Northvolt AB &nbsp; ⌁</li>
            {bottomLinks.map(link => (
              <li key={link.id}>
                {isExternal(link.url) ? (
                  <a href={link.url} target="_blank" rel="noreferrer">
                    {link.title}
                  </a>
                ) : (
                  <Link to={link.url}>{link.title}</Link>
                )}
              </li>
            ))}
          </ul>
        </div>
      </section>
    </footer>
  )
}

export default Footer
